<div [ngClass]="position == 'fixed'? 'fixed-loading' : 'loading' " [style.minHeight]="minHeight != defaultMinHeight ? minHeight : null ">
  <mat-spinner [diameter]="25"></mat-spinner>
</div>
